<div class="layout-col">
  <button
    mat-icon-button
    aria-label="Service Links"
    [matMenuTriggerFor]="orderMenu"
    [disabled]="!serviceLinks || serviceLinks.length === 0"
  >
    <mat-icon>apps</mat-icon>
  </button>

  <mat-menu #orderMenu="matMenu">
    @for (serviceLink of serviceLinks; track serviceLink) {
      <ng-container
        *ngTemplateOutlet="serviceLinkTemplate; context: { serviceLink: serviceLink }"
      ></ng-container>
    }
  </mat-menu>
</div>

<ng-template #serviceLinkTemplate let-serviceLink="serviceLink">
  <a mat-menu-item [href]="serviceLink.url" [target]="'blank'">
    <mat-icon>exit_to_app</mat-icon>
    <span>{{ serviceLink.name }}</span>
  </a>
</ng-template>
